import { statusOptions } from "data/globalData";
import { attrGroupLinkedTables } from "components/PimDashboard/data";
import { sourcingOnlyColorColumnKeys } from "components/PimDashboard/DashboardComponents/Sourcing/FabricStylesDashboard/EditFabricStyleDetails/data";
import { validateMandatoryFields } from "utils/mandatoryFieldsLogic";

export const isColorRejected = (color) => color?.rejected === true || color?.status === statusOptions.REJECTED.key;

/**
 * Mandatory attributes that are still empty for this style.
 * Same rules as the style publish modal: style, style details (except fabric_details),
 * and non-rejected colors. Duplicate keys are collapsed to one entry.
 */
export const getPendingRequiredFields = (styleDetails, allAttributes = []) => {
	if (!styleDetails || !allAttributes?.length) return [];

	const brand = styleDetails?.[attrGroupLinkedTables.style.key]?.brand || "";
	const category = styleDetails?.[attrGroupLinkedTables.style.key]?.category || "";

	const styleAttrs = allAttributes.filter((row) => row.linked_table === attrGroupLinkedTables.style.key);
	const styleDetailsAttrs = allAttributes.filter(
		(row) => row.linked_table === attrGroupLinkedTables.style_details.key && row.group_id !== "fabric_details",
	);

	const styleValidation = validateMandatoryFields(styleDetails, styleAttrs, brand, category, attrGroupLinkedTables.style.key);
	const styleDetailsValidation = validateMandatoryFields(
		styleDetails,
		styleDetailsAttrs,
		brand,
		category,
		attrGroupLinkedTables.style_details.key,
	);

	let pendingFields = [...styleValidation.missingFields, ...styleDetailsValidation.missingFields];

	styleDetails?.[attrGroupLinkedTables.color.key]?.forEach((colorRow) => {
		if (isColorRejected(colorRow)) return;

		const colorAttrs = allAttributes.filter(
			(row) => row.linked_table === attrGroupLinkedTables.color.key && !sourcingOnlyColorColumnKeys.includes(row.key),
		);

		const colorValidation = validateMandatoryFields(colorRow, colorAttrs, brand, category, null);
		pendingFields.push(...colorValidation.missingFields);
	});

	return Object.values(
		pendingFields.reduce((acc, row) => {
			acc[row.key] = row;
			return acc;
		}, {}),
	);
};
